<template>
	<el-select v-if="multiple" class="gim-select"  ref="sel" :clearable="clearable" filterable 
	:size="size" default-first-option reserve-keyword collapse-tags multiple 
	@visible-change="trigglePlaceholder" v-bind="$attrs" v-model="selectValue" @input="input"
	:class="selectClass">
		<div v-show="showMoreOptions">
			<el-switch class="option" @input="input" v-model="isExclude" />
			<el-checkbox class="option" @input="input" @change="selectAll" />
			<slot/>
		</div>
		<el-option :class="item.class+ ' row '" v-for="item in options" :key="item.label" :label="item.label" :value="item.value" />
	</el-select>
	<el-select v-else class="gim-select" :clearable="clearable" filterable :size="size" default-first-option 
	reserve-keyword collapse-tags @visible-change="trigglePlaceholder" @input="input" v-bind="$attrs" v-model="selectValue">
		<slot/>
		<el-option :class="item.class+ ' row '" v-for="item in options" :key="item.label" :label="item.label" :value="item.value" />
	</el-select>

</template>

<script>
export default {
	data() {
		return {
			isExclude: this.initFromValue(this.value).isExclude,
			selectValue: this.initFromValue(this.value).selectValue,
		};
	},
	props: {
		value: {
			required: true,
			default() {
				return "";
			}
		},
		options: { type: Array, required: true },
		multiple: {
			type: Boolean
		},
		showMoreOptions: {
			type: Boolean,
			default() {
				return true;
			}
		},
		clearable: {
			type: Boolean,
			default() {
				return true;
			}
		},
		returnArray:Boolean,
		size: {
			type: String,
			default() {
				return 'small';
			}
		}
	},
	watch: {
		value(newV) {
			if(this.multiple){
				const result = this.initFromValue(newV);
				this.selectValue = result.selectValue;
				this.isExclude = result.isExclude;
				setTimeout(()=>this.displayPlaceholder(),0);
			}else{
				this.selectValue = newV;
			}
		},
	},
	computed: {
		optionsObj() {
			const result = {};
			for (let { value, label } of this.options) {
				result[value] = label;
			}
			return result;
		},
		allValues() {
			return this.options.map(v => v.value);
		},
		selectClass(){
			let className = '';
			if(this.multiple){
				if(this.selectValue && this.selectValue.length>0){
					className = 'mm-selected ';
					if(this.isExclude){
						className = 'mm-selected-exclude';
					}
				}
				
			}
			return className;
		}
	},
	methods: {
		initFromValue(v) {
			let selectValue = v;
			let isExclude = false;
			if (this.multiple) {
				selectValue = selectValue || [];
				if(this.returnArray){
					if(this.isExclude){
						isExclude = true;
						selectValue = this.$utils._.difference(this.allValues,v);
					}
				}
				else if (v.$nin) {
					isExclude = true;
					selectValue = v.$nin;
				} else if(v.$in) {
					selectValue = v.$in;
				}
			}
			return { selectValue, isExclude };
		},
		selectAll(check) {
			const selectValue = {};
			(this.selectValue || []).forEach(v=>selectValue[v]=v);
			this.$refs.sel.options.forEach(function(option){
				if(!option.visible){
					return;
				}
				if(check){
					selectValue[option.value] = option.value;
				}else{
					delete selectValue[option.value];
				}
			})
			this.selectValue = Object.values(selectValue);
			this.input();

		},
		trigglePlaceholder(visible) {
			this.displayPlaceholder();
		},
		displayPlaceholder() {
			if (!this.multiple) {
				return;
			}
			const value = this.selectValue;
			let result = "Select";
			if (value && value.length > 0) {
				result = value
					.slice(0, 4)
					.map(v => this.optionsObj[v])
					.join(",");
			}
			if (result.length > 10) {
				result = result.slice(0, 8) + " ...";
			}
			this.$refs.sel.currentPlaceholder = result;
		},
		input() {
			const value = this.selectValue;
			const isExclude = this.isExclude;
			let result = value;
			if (this.multiple) {
				if(this.returnArray){
					if(isExclude){
						result = this.$utils._.difference(this.allValues,value);
					}else{
						result = value;
					}
				}
				else if (!value.length) {
					result = '';
				} else if (isExclude) {
					result = { $nin: value };
				} else {
					result = { $in: value };
				}
			}
			this.$emit("input", result);
			this.$emit("change", result);
		}
	},
	mounted() {
		this.displayPlaceholder();
	}
};
</script>
<style scoped>
.option {
	margin-left:30px;
	margin-bottom: 10px;
}
.row{
	display: block;
}

</style>




